import { render, staticRenderFns } from "./ApplianceModelShow.vue?vue&type=template&id=b6bfdc6e"
import script from "./ApplianceModelShow.vue?vue&type=script&lang=js"
export * from "./ApplianceModelShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports